import React, { Suspense, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import InfoDropdown from "./InfoDropdown";
import { AnimatePresence, motion } from "framer-motion";
import FirstAsset from "../../assets/imgs/landingPage/first.webp";
import { useNavigate } from "react-router-dom";
const ReactPlayer = React.lazy(() => import("react-player"));


const Fold2 = () => {

  const [playing, setPlaying] = useState(false); // State to manage video playback

  const navigate = useNavigate();
  const dropdownList = [
    {
      id: 0,
      dropdownTitle: "Start your app growth",
      text: "Drive installs, boost engagement by guiding users to the right content with deep links, increase referrals, and maximize your marketing budget ROI with easy-to-use reporting and analytics.",
      learnMore: () => navigate("/app-growth"),
    },
    {
      id: 1,
      dropdownTitle: "Maximise user acquisition",
      text: "Increase user acquisition by identifying the most effective parts of each campaign. Use powerful tools to improve your strategy, get better results, and drive growth.",
      learnMore: () => navigate("/measure"),
    },
    {
      id: 2,
      dropdownTitle: "Increase engagement and LTV",
      text: "Drive higher engagement and increase lifetime value by turning data insights into personalised experiences that retain the right users and maximise their value.",
      learnMore: () => navigate("/increase-engagement"),
    },
    {
      id: 3,
      dropdownTitle: "Cross-App Alerts",
      text: "Reach users with the right message at the right time by automating targeted communications across all your apps from one centralised platform. Keep engagement high and drive action with seamless cross-app messaging.",
      learnMore: () => navigate("/messaging"),
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"product"}>
        <Line>
          <TextWrapper>
            <Title>
              More Installs. Deeper Engagement.
              <br />
              Maximum ROI.
            </Title>
            <Subtitle>
              Launch and scale your app with tools that drive installs and boost
              engagement. Increase referrals and maximize ROI through deep
              links, smart messaging, and data-driven optimization across the
              entire user journey.
            </Subtitle>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  infoText={item.text}
                  dropdownTitle={item.dropdownTitle}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
            <CardWrapper>
              {!playing &&
                <ImageContainer>
                  <img src={FirstAsset} alt="intro" decoding="async" />
                </ImageContainer>
              }
              <VideoWrapper>
                {playing &&
                  <Suspense fallback={null}>
                    <ReactPlayer
                      url="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/Welcome-2.mp4" // Replace with your actual S3 URL
                      playing={playing} // Control playback with state
                      controls={playing ?? false}
                      width="100%"
                      height="100%"
                    />
                  </Suspense>}

                {!playing && (
                  <PlayButton onClick={() => setPlaying(true)}>▶</PlayButton>
                )}
              </VideoWrapper>

            </CardWrapper>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default Fold2;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:150px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    line-height: 24px;
    text-align: center;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  position:relative;
max-width:650px;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: absolute;
    border-radius: 15px;
z-index:2;
img{
aspect-ratio: 16/9;
width:100%;
}
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};

  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
    align-items:center;
  width: 100%;
  gap: 16px;
`;


const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  aspect-ratio: 16/9;
  svg {
  & > div {
      position: absolute;
   top: 0;
    left: 0;
     width: 100%;
    height: 100%;
    border-radius: 15px;
   }
 `;

const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 50px;
  border: none;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index:2;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;

